import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const TestimonialsPage = lazy(() => import('../pages/testimonials/page'));
const PaymentPage = lazy(() => import('../pages/payment/page'));
const InfoPage = lazy(() => import('../pages/info/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/testimonials',
    element: <TestimonialsPage />,
  },
  {
    path: '/payment',
    element: <PaymentPage />,
  },
  {
    path: '/info',
    element: <InfoPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
